import {useIntl} from 'react-intl';
import React from 'react';
import {
  Checkbox,
  Input,
  Button
} from 'semantic-ui-react'

const SoftTissueExam = (props: any) => {
    const intl = useIntl();
    const isMounted = React.useRef(true);

    React.useEffect(() => {
        return () => {
            isMounted.current = false;
        };
    }, []);


    return(
      <div
        style={{ width: "100%", height: "100%", padding: "5px" }}>
        <div
          style={{ padding: "8px",  backgroundColor: "#2D9CDB", color:"white",fontWeight: "bold", fontSize: "1.5em" }}>
          {intl.formatMessage({id: "cukey142"})}
        </div>
        <div
          style={{ padding: "10px", display: "grid", gridTemplateColumns: "25% 25% 50%", gridTemplateRows: "repeat(6, 1fr)" }}>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <label
              style={{ marginRight: "10px", fontWeight:"bold" }}>
              {intl.formatMessage({id: "cukey186"})}
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <Checkbox
              checked={props.softTissueExamData?.salivaryglands1?.value}
              label="Normal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "salivaryglands1", value: checked,text:label  } })}
              style={{ marginRight: "10px" }}>
            </Checkbox>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <Checkbox
              checked={props.softTissueExamData?.salivaryglands2?.value}
              label="Abnormal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "salivaryglands2", value: checked,text:label  } })}
              style={{ marginRight: "10px" }}>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "salivaryglands3", value: value, text: value, input: true } })}
              value={props.softTissueExamData?.salivaryglands3?.value}>
            </Input>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <label
              style={{ marginRight: "10px", fontWeight:"bold"  }}>
              {intl.formatMessage({id: "cukey108"})}
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <Checkbox
              checked={props.softTissueExamData?.libs1?.value}
              label="Normal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "libs1", value: checked,text:label  } })}
              style={{ marginRight: "10px" }}>
            </Checkbox>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            <Checkbox
              checked={props.softTissueExamData?.libs2?.value}
              label="Abnormal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "libs2", value: checked,text:label  } })}
              style={{ marginRight: "10px" }}>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "libs3", value: value, text: value, input: true } })}
              value={props.softTissueExamData?.libs3?.value}>
            </Input>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <label
              style={{  marginRight: "10px", fontWeight:"bold"  }}>
              {intl.formatMessage({id: "cukey105"})}
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.softTissueExamData?.labialMucosa1?.value}
              label="Normal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "labialMucosa1", value: checked,text:label  } })}
              style={{ marginRight: "10px" }}>
            </Checkbox>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.softTissueExamData?.labialMucosa2?.value}
              label="Abnormal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "labialMucosa2", value: checked,text:label  } })}
              style={{ marginRight: "10px" }}>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "labialMucosa3", value: value, text: value, input: true } })}
              value={props.softTissueExamData?.labialMucosa3?.value}>
            </Input>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <label
              style={{  marginRight: "10px", fontWeight:"bold"  }}>
              {intl.formatMessage({id: "cukey42"})}
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.softTissueExamData?.buccalMucosa1?.value}
              label="Normal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "buccalMucosa1", value: checked,text:label  } })}
              style={{  marginRight: "10px" }}>
            </Checkbox>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.softTissueExamData?.buccalMucosa2?.value}
              label="Abnormal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "buccalMucosa2", value: checked,text:label  } })}
              style={{ marginRight: "10px" }}>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "buccalMucosa3", value: value, text: value, input: true } })}
              value={props.softTissueExamData?.buccalMucosa3?.value}>
            </Input>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <label
              style={{  marginRight: "10px", fontWeight:"bold"  }}>
              {intl.formatMessage({id: "cukey153"})}
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.softTissueExamData?.palate1?.value}
              label="Normal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "palate1", value: checked,text:label  } })}
              style={{marginRight: "10px" }}>
            </Checkbox>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.softTissueExamData?.palate2?.value}
              label="Abnormal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "palate2", value: checked,text:label  } })}
              style={{marginRight: "10px" }}>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "palate3", value: value, text: value, input: true } })}
              value={props.softTissueExamData?.palate3?.value}>
            </Input>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <label
              style={{  marginRight: "10px", fontWeight:"bold"  }}>
              {intl.formatMessage({id: "cukey205"})}
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.softTissueExamData?.tongue1?.value}
              label="Normal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "tongue1", value: checked,text:label  } })}
              style={{  marginRight: "10px"  }}>
            </Checkbox>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.softTissueExamData?.tongue2?.value}
              label="Abnormal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "tongue2", value: checked,text:label  } })}
              style={{  marginRight: "10px"  }}>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "tongue3", value: value, text: value, input: true } })}
              value={props.softTissueExamData?.tongue3?.value}>
            </Input>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <label
              style={{  marginRight: "10px", fontWeight:"bold"  }}>
              {intl.formatMessage({id: "cukey80"})}
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.softTissueExamData?.floorMouth1?.value}
              label="Normal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "floorMouth1", value: checked,text:label  } })}
              style={{  marginRight: "10px"  }}>
            </Checkbox>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.softTissueExamData?.floorMouth2?.value}
              label="Abnormal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "floorMouth2", value: checked,text:label  } })}
              style={{  marginRight: "10px"}}>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "floorMouth3", value: value, text: value, input: true } })}
              value={props.softTissueExamData?.floorMouth3?.value}>
            </Input>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <label
              style={{  marginRight: "10px", fontWeight:"bold"  }}>
              {intl.formatMessage({id: "cukey144"})}
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.softTissueExamData?.oropharynx1?.value}
              label="Normal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "oropharynx1", value: checked,text:label  } })}>
            </Checkbox>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Checkbox
              checked={props.softTissueExamData?.oropharynx2?.value}
              label="Abnormal"
              onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "oropharynx2", value: checked,text:label  } })}
              style={{  marginRight: "10px"}}>
            </Checkbox>
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "oropharynx3", value: value, text: value, input: true } })}
              value={props.softTissueExamData?.oropharynx3?.value}>
            </Input>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <label
              style={{  marginRight: "10px", fontWeight:"bold"  }}>
              {intl.formatMessage({id: "cukey132"})} 
            </label>
          </div>
          <div
            style={{display: "flex", alignItems: "center", margin: "5px" }}>
            
            <Input
              onChange={(e, { value }) => props.onEvent({ message: "SetCheckedSoftTissueExam", params: { name: "numericalRating1", value: value, text: value, input: true } })}
              value={props.softTissueExamData?.numericalRating1?.value}>
            </Input>
          </div>
        </div>
        <div
          style={{display:"flex", justifyContent:"center"}}>
          {}
          <Button
            color="green"
            onClick={props.handleSaveSoftTissueExam}
            style={{margin:"5px 0"}}>
            {intl.formatMessage({id: "cukey187"})}
          </Button>
        </div>
      </div>
    )
}

export default SoftTissueExam

export const screenPropsDefault = {}

/* Date Time : Wed May 19 2021 05:51:09 GMT+0000 (Coordinated Universal Time)
/* Original screen Data **************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", height: \"100%\", padding: \"5px\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey142"})}
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"8px\",  backgroundColor: \"#2D9CDB\", color:\"white\",fontWeight: \"bold\", fontSize: \"1.5em\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "style": {
          "type": "code",
          "value": "{ padding: \"10px\", display: \"grid\", gridTemplateColumns: \"25% 25% 50%\", gridTemplateRows: \"repeat(6, 1fr)\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 2,
      "props": {
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Checkbox",
      "parent": 4,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.softTissueExamData?.salivaryglands1?.value"
        },
        "label": {
          "type": "value",
          "value": "Normal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"salivaryglands1\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "Checkbox",
      "parent": 5,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.softTissueExamData?.salivaryglands2?.value"
        },
        "label": {
          "type": "value",
          "value": "Abnormal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"salivaryglands2\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        },
        "toggle": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 28,
      "name": "Checkbox",
      "parent": 10,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.softTissueExamData?.libs1?.value"
        },
        "label": {
          "type": "value",
          "value": "Normal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"libs1\", value: checked,text:label  } })"
        },
        "onClick": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 29,
      "name": "Checkbox",
      "parent": 11,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.softTissueExamData?.libs2?.value"
        },
        "label": {
          "type": "value",
          "value": "Abnormal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"libs2\", value: checked,text:label  } })"
        },
        "onClick": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "label",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey186"})}
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\", fontWeight:\"bold\" }"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "label",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey108"})}
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "Input",
      "parent": 5,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"salivaryglands3\", value: value, input: true } })"
        },
        "value": {
          "type": "code",
          "value": "props.softTissueExamData?.salivaryglands3?.value"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "Input",
      "parent": 11,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"libs3\", value: value, input: true } })"
        },
        "value": {
          "type": "code",
          "value": "props.softTissueExamData?.libs3?.value"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\", justifyContent:\"center\"}"
        }
      },
      "seq": 198,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "Button",
      "parent": 87,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey187"})}
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "onClick": {
          "type": "code",
          "value": "props.handleSaveSoftTissueExam"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"5px 0\"}"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": null,
      "id": 99,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": null,
      "id": 105,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "label",
      "parent": 99,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey105"})}
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "label",
      "parent": 104,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey42"})}
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 110,
      "name": "Checkbox",
      "parent": 98,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.softTissueExamData?.labialMucosa1?.value"
        },
        "label": {
          "type": "value",
          "value": "Normal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"labialMucosa1\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "Checkbox",
      "parent": 100,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.softTissueExamData?.labialMucosa2?.value"
        },
        "label": {
          "type": "value",
          "value": "Abnormal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"labialMucosa2\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 114,
      "name": "Checkbox",
      "parent": 105,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.softTissueExamData?.buccalMucosa1?.value"
        },
        "label": {
          "type": "value",
          "value": "Normal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"buccalMucosa1\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\" }"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "Checkbox",
      "parent": 106,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.softTissueExamData?.buccalMucosa2?.value"
        },
        "label": {
          "type": "value",
          "value": "Abnormal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"buccalMucosa2\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 123,
      "name": "Input",
      "parent": 106,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"buccalMucosa3\", value: value, input: true } })"
        },
        "value": {
          "type": "code",
          "value": "props.softTissueExamData?.buccalMucosa3?.value"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 125,
      "name": "Input",
      "parent": 100,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"labialMucosa3\", value: value, input: true } })"
        },
        "value": {
          "type": "code",
          "value": "props.softTissueExamData?.labialMucosa3?.value"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": null,
      "id": 137,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": null,
      "id": 138,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 142,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": null,
      "id": 143,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": null,
      "id": 144,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": null,
      "id": 148,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": null,
      "id": 149,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": null,
      "id": 150,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": null,
      "id": 154,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": null,
      "id": 155,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 156,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": null,
      "id": 160,
      "name": "label",
      "parent": 136,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey153"})}
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 166,
      "name": "Checkbox",
      "parent": 137,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.softTissueExamData?.palate1?.value"
        },
        "label": {
          "type": "value",
          "value": "Normal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"palate1\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\" }"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 167,
      "name": "Checkbox",
      "parent": 138,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.softTissueExamData?.palate2?.value"
        },
        "label": {
          "type": "value",
          "value": "Abnormal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"palate2\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\" }"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 170,
      "name": "Input",
      "parent": 138,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"palate3\", value: value, input: true } })"
        },
        "value": {
          "type": "code",
          "value": "props.softTissueExamData?.palate3?.value"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": null,
      "id": 172,
      "name": "label",
      "parent": 142,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey205"})}
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 173,
      "name": "Checkbox",
      "parent": 143,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.softTissueExamData?.tongue1?.value"
        },
        "label": {
          "type": "value",
          "value": "Normal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"tongue1\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\"  }"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 174,
      "name": "Checkbox",
      "parent": 144,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.softTissueExamData?.tongue2?.value"
        },
        "label": {
          "type": "value",
          "value": "Abnormal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"tongue2\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\"  }"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 178,
      "name": "Input",
      "parent": 144,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"tongue3\", value: value, input: true } })"
        },
        "value": {
          "type": "code",
          "value": "props.softTissueExamData?.tongue3?.value"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": null,
      "id": 180,
      "name": "label",
      "parent": 148,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey80"})}
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 182,
      "name": "Checkbox",
      "parent": 149,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.softTissueExamData?.floorMouth1?.value"
        },
        "label": {
          "type": "value",
          "value": "Normal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"floorMouth1\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\"  }"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 183,
      "name": "Checkbox",
      "parent": 150,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.softTissueExamData?.floorMouth2?.value"
        },
        "label": {
          "type": "value",
          "value": "Abnormal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"floorMouth2\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\"}"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 186,
      "name": "Input",
      "parent": 150,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"floorMouth3\", value: value, input: true } })"
        },
        "value": {
          "type": "code",
          "value": "props.softTissueExamData?.floorMouth3?.value"
        }
      },
      "seq": 186,
      "void": false
    },
    {
      "from": null,
      "id": 188,
      "name": "label",
      "parent": 154,
      "props": {
        "children": {
          "type": "value",
          "value": {intl.formatMessage({id: "cukey144"})}
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 190,
      "name": "Checkbox",
      "parent": 155,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.softTissueExamData?.oropharynx1?.value"
        },
        "label": {
          "type": "value",
          "value": "Normal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"oropharynx1\", value: checked,text:label  } })"
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 191,
      "name": "Checkbox",
      "parent": 156,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.softTissueExamData?.oropharynx2?.value"
        },
        "label": {
          "type": "value",
          "value": "Abnormal"
        },
        "onChange": {
          "type": "code",
          "value": "(e, { checked, label }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"oropharynx2\", value: checked,text:label  } })"
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\"}"
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 195,
      "name": "Input",
      "parent": 156,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"oropharynx3\", value: value, input: true } })"
        },
        "value": {
          "type": "code",
          "value": "props.softTissueExamData?.oropharynx3?.value"
        }
      },
      "seq": 195,
      "void": false
    },
    {
      "from": null,
      "id": 196,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 196,
      "void": false
    },
    {
      "from": null,
      "id": 197,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"5px\" }"
        }
      },
      "seq": 197,
      "void": false
    },
    {
      "from": null,
      "id": 198,
      "name": "label",
      "parent": 196,
      "props": {
        "children": {
          "type": "value",
          "value": "Numerical rating scale (0-10) : "
        },
        "style": {
          "type": "code",
          "value": "{  marginRight: \"10px\", fontWeight:\"bold\"  }"
        }
      },
      "seq": 198,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 199,
      "name": "Input",
      "parent": 197,
      "props": {
        "onChange": {
          "type": "code",
          "value": "(e, { value }) => props.onEvent({ message: \"SetCheckedSoftTissueExam\", params: { name: \"numericalRating1\", value: value, input: true } })"
        },
        "value": {
          "type": "code",
          "value": "props.softTissueExamData?.numericalRating1?.value"
        }
      },
      "seq": 199,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 40,
  "isMounted": true,
  "memo": false,
  "name": "SoftTissueExam",
  "project": "cudent",
  "screenPropsDefault": {
  },
  "width": 55
}

************************************************************************************* */
